import { render, staticRenderFns } from "./LeftDrawer.vue?vue&type=template&id=27917c8e&scoped=true"
import script from "./LeftDrawer.vue?vue&type=script&lang=js"
export * from "./LeftDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27917c8e",
  null
  
)

export default component.exports